<template>
  <div>
    <RF-Aba :cpntButtons='buttons'></RF-Aba>
  </div>
</template>

<style>
  div > .rf-config-tab {
    width: 100%;
  }
</style>

<script>
  export default {
    components: {
      'RF-Aba': () => import('@/components/rf-geral/aba/RF-Aba.vue')
    },
    data: function () {
      return {
        buttons: []
      }
    },
    mounted: function () {
      if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 20, 23, 25, 31 ], 'or', null, null, [ 526, 527, 537, 913 ], 'or', true) === true) {
        // RESETA O MENU EXISTENTE
        this.buttons = []

        // ADICIONA A ABA AGENDAEMNTO
        this.buttons.push({ nome: 'Recorrência', router: this.$router.resolve({ name: 'df_exp_rec', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'df_exp_rec', 'df_exp_rec_form' ] })

        // ADICIONA A ABA EXPORTAÇÃO
        this.buttons.push({ nome: 'Exportação', router: this.$router.resolve({ name: 'df_exp', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'df_exp', 'df_exp_form' ] })

        // VERIFICA SE DEVE ADICIONAR UM NOVO BOTÃO
        if ([ '3126', '3154', '3155', '9122', '9123', '9124' ].indexOf(this.$store.state.token.clu) !== -1) {
          this.buttons.push({ nome: 'Relatorio NCM x Qtde', router: this.$router.resolve({ name: 'df_exp_rel_tatiana', params: { cts: this.$store.state.token.cts } }).href, aRouterSelect: [ 'df_exp_rel_tatiana' ] })
        }
      }
    }
  }
</script>
